<h5 class="text-zen text-2xl font-medium">
    {{'txtENPS'| translate:language:ModuleNames.Engagement}}
</h5>
<div class="flex flex-row p-5 bg-white  rounded-lg gap-5">
    <div class="flex flex-col p-5 justify-center items-center gap-5 w-5/12 bg-zen bg-opacity-5 rounded-lg">
        <div class="flex flex-row gap-5 w-full justify-center items-center">
            <i class="fas fa-th-list text-7xl text-exp"></i>
            <h5 [@child33] [ngClass]="{'dirLTR': (language | language )}" class="text-zen text-6xl font-medium">
                {{toFixed(enpsAnalysis.finalENPS, 1)}}%
            </h5>
        </div>
        <div [@smallAnimation] class="flex flex-col gap-1 items-stretch">
            <ng-content select="[benchmark]"></ng-content>
        </div>
    </div>
    <div class="flex flex-col  items-center gap-3 w-7/12">
        <div class="flex flex-col gap-2 w-full">
            <div class="flex flex-row justify-between items-center">
                <h5 [@child34] class="text-zen font-medium">
                    {{'txtPromoters'|
                    translate:language:ModuleNames.Engagement}}
                </h5>
                <h5 [@child35] class="text-zen font-medium">
                    {{enpsAnalysis.promoters}}({{toFixed(enpsAnalysis.promotersPerc, 1)}}%)
                </h5>
            </div>
            <div [@child36]
                class="flex flex-row justify-start h-10 w-full bg-zen-green bg-opacity-10 rounded-lg overflow-hidden">
                <div [style.width.%]="enpsAnalysis.promotersPerc" class="h-10 w-full bg-zen-green"></div>
            </div>
        </div>


        <div class="flex flex-col gap-2 w-full">
            <div class="flex flex-row justify-between items-center">
                <h5 [@child36] class="text-zen font-medium">
                    {{'txtPassives'| translate:language:ModuleNames.Engagement}}
                </h5>
                <h5 [@child37] class="text-zen font-medium">
                    {{enpsAnalysis.passive}}({{toFixed(enpsAnalysis.passivePerc, 1)}}%)
                </h5>
            </div>
            <div [@child38]
                class="flex flex-row justify-start h-10 w-full bg-yellow-400 bg-opacity-10 rounded-lg overflow-hidden">
                <div [style.width.%]="enpsAnalysis.passivePerc" class="h-10 w-full bg-yellow-400"></div>
            </div>
        </div>


        <div class="flex flex-col gap-2 w-full">
            <div class="flex flex-row justify-between items-center">
                <h5 [@child37] class="text-zen font-medium">
                    {{'txtDetractors'|
                    translate:language:ModuleNames.Engagement}}
                </h5>
                <h5 [@child38] class="text-zen font-medium">
                    {{enpsAnalysis.detractors}}({{toFixed(enpsAnalysis.detractorsPerc, 1)}}%)
                </h5>
            </div>
            <div [@child39]
                class="flex flex-row justify-start h-10 w-full bg-zen-red bg-opacity-10 rounded-lg overflow-hidden">
                <div [style.width.%]="enpsAnalysis.detractorsPerc" class="h-10 w-full bg-zen-red"></div>
            </div>
        </div>
    </div>
</div>